export enum ROUTES {
  HOME='/',
  CONTACT='/contact',
  ABOUT='/about',
  USER_EXPERIENCE_DESIGN='/services/user-experience-design',
  ECOMMERCE_SOLUTIONS='/services/ecommerce-solutions',
  WEB_DEVELOPMENT='/services/web-development',
  MOBILE_APP_DEVELOPMENT='/services/mobile-app-development',
  CUSTOM_SOFTWARE_DESIGN='/services/custom-software-design-solutions',
}